import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack, TextField, Divider, Alert, Snackbar, Checkbox, Card, CardContent, Grid2, CardHeader } from "@mui/material";
import { isStudent, useAuth } from "../../contexts/AuthContext";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import AsyncButton from "../../components/common/AsyncButton";
import { useAsyncAction } from "../../components/common/useAsyncAction";
import { SampleData, AddedQuestionSampleData } from "./SampleData";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { InvokeAPI } from "../../apis/API";
import { getAssessmentMgmtBase } from "../../config/apiBase";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AddCircle } from "@mui/icons-material";
import ClassIcon from '@mui/icons-material/Class';
import SchoolIcon from '@mui/icons-material/School';
import LabelIcon from '@mui/icons-material/Label';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';


const AssessmentQuestionEdit = () => {
    const { id } = useParams();

    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const [categories, setCategories] = useState({})
    const [subjects, setSubjects] = useState([])
    const [questions, setQuestions] = useState([])
    const [search, setSearch] = useState({
        subject: '',
        class: '',
        category: '',
        easy: true,
        medium: true,
        advanced: true,
    })
    const [selectedQuestions, setSelectedQuestions] = useState({})

    const getCategories = async () => {
        const categories = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/categories`,
            {},
            'POST',
            { "authorization": user["token"] },
            false)
        if (categories["unauthenticated"] == true || categories["unauthorized"] == true) {
            logout(user);
        }
        if (categories.internal) {
            return undefined
        }
        console.log(categories)
        const hash = categories.response.Categories.reduce((acc, item) => {
            acc[item.Sname] = acc[item.Sname] || {};
            acc[item.Sname][item.Cls] = acc[item.Sname][item.Cls] || [];
            acc[item.Sname][item.Cls].push(item.Cname);
            return acc;
        }, {});
        console.log(hash);
        return hash
    }

    useEffect(() => {
        //Some function
        getCategories().then(data => {
            setCategories(data || {})
            if (data) {
                // Extract subjects from categories
                const subjectList = Object.keys(data);
                setSubjects(subjectList);
            }
        })
    }, [])

    // Auto-select first subject/class/category when category metadata is loaded.
    useEffect(() => {
        if (subjects.length > 0 && !search.subject && Object.keys(categories).length > 0) {
            const firstSubject = subjects[0];
            setSearch(prev => {
                if (prev.subject) return prev;
                const newData = { ...prev, subject: firstSubject, class: '', category: '' };
                if (categories[firstSubject]) {
                    const classes = Object.keys(categories[firstSubject]);
                    if (classes.length > 0) {
                        newData.class = classes[0];
                        const categoriesForClass = categories[firstSubject][classes[0]];
                        if (categoriesForClass && categoriesForClass.length > 0) {
                            newData.category = categoriesForClass[0];
                        }
                    }
                }
                return newData;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subjects.length, Object.keys(categories).length]);

    const RenderManuallyAddQuestion = () => {
        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Accordion sx={{ border: 1, color: 'primary.main' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="manually-add-content"
                        id="manually-add"
                    >
                        <Typography component="span">Manually Add</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ color: 'black' }}>
                        <TextField
                            label="Question"
                            variant="outlined"
                            name="question"
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                        <TextField
                            label="Answer"
                            variant="outlined"
                            name="answer"
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                        <TextField
                            label="Solution"
                            variant="outlined"
                            name="solution"
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                        <Button type="button" variant="contained" color="primary" >
                            Add
                        </Button>
                    </AccordionDetails>
                </Accordion>
            </Box>
        )
    }

    const RenderAskAIForQuestion = () => {
        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Accordion sx={{ border: 1, color: 'primary.main' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="render-ask-ai-content"
                        id="render-ask-ai"
                    >
                        <Typography component="span">Ask AI</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ color: 'black' }}>
                        Search with AI and display things as selectable tables
                    </AccordionDetails>
                </Accordion>
            </Box>
        )
    }

    const RenderSearchAndAddQuestions = () => {
        const { run: runSearch, loading: searching } = useAsyncAction();
        const { run: runAddQuestions, loading: addingQuestions } = useAsyncAction();

        const handleChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            if (name === 'subject') {
                // Reset class and category when subject changes
                setSearch({ ...search, subject: value, class: '', category: '' });
                // Auto-select first class for new subject
                if (categories[value]) {
                    const classes = Object.keys(categories[value]);
                    if (classes.length > 0) {
                        setTimeout(() => {
                            const firstClass = classes[0];
                            setSearch(prev => {
                                const newData = { ...prev, class: firstClass, category: '' };
                                // Auto-select first category if available
                                const categoriesForClass = categories[value][firstClass];
                                if (categoriesForClass && categoriesForClass.length > 0) {
                                    newData.category = categoriesForClass[0];
                                }
                                return newData;
                            });
                        }, 0);
                    }
                }
            } else if (name === 'class') {
                // Reset category when class changes
                setSearch({ ...search, class: value, category: '' });
                // Auto-select first category for new class
                if (search.subject && categories[search.subject] && categories[search.subject][value]) {
                    const categoriesForClass = categories[search.subject][value];
                    if (categoriesForClass && categoriesForClass.length > 0) {
                        setTimeout(() => {
                            setSearch(prev => ({ ...prev, category: categoriesForClass[0] }));
                        }, 0);
                    }
                }
            } else {
                setSearch({ ...search, [name]: value });
            }
        }

        const handleLevelChange = (e) => {
            //e.preventDefault();
            const name = e.target.id;
            const value = e.target.checked;
            setSearch({ ...search, [name]: value });
        }

        const handleSearch = async (e) => {
            e?.preventDefault();
            await runSearch(async () => {
                const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/search`,
                    {
                        "Qsubject": search.subject,
                        "Qclass": search.class,
                        "Qcategory": search.category,
                        "Easy": search.easy,
                        "Medium": search.medium,
                        "Advanced": search.advanced,
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                    logout(user);
                }
                if (uinfo.internal) {
                    return undefined
                }
                //console.log(uinfo)
                setQuestions(uinfo.response["QuestionsInfo"])
            });
        }

        const handleQuestionsSelect = (e) => {
            const name = e.target.id
            const value = e.target.checked
            setSelectedQuestions({ ...selectedQuestions, [name]: value })
        }

        const handleAddQuestions = async (e) => {
            e.preventDefault();
            await runAddQuestions(async () => {
                const listOfQuestions = [];
                for (const [key, value] of Object.entries(selectedQuestions)) {
                    if (value == true) {
                        listOfQuestions.push(key)
                    }
                }
                //TODO: check for length and then only call the API
                const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/add`,
                    {
                        "Aid": id,
                        "Qid": listOfQuestions,
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                    logout(user);
                } else {
                    setState({ open: true, severity: "success", message: "Questions added successfully" })
                    navigate("/app/practice/edit/" + id)
                }
            });
        }

        const renderQuestions = (questions) => {
            return (
                <>
                    {questions.map((qlist, index) => (
                        <Grid2 key={`question-${index}`} size={{ xs: 12, sm: 12, md: 12 }} sx={{ paddingBottom: "20px" }}>
                            <Card
                                elevation={6}
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    position: 'relative',
                                    borderRadius: 3,
                                    paddingRight: "5px",
                                    paddingLeft: "5px",
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-4px)',
                                    },
                                }}>
                                <CardContent>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Level: {qlist.Qlevel}
                                        </Typography>
                                        <Typography display="none" variant="body2" color="text.secondary">
                                            Format: {qlist.Options.length !== 0 ? "MCQ" : "Type in Answer"}
                                        </Typography>
                                    </Box>
                                    <Checkbox checked={selectedQuestions[qlist.QID]} id={qlist.QID} onChange={handleQuestionsSelect} /><b>Question:</b> {qlist.Question} &nbsp;
                                    {qlist.Options.length !== 0 && <Box display="flex" style={{ paddingLeft: "50px" }}>
                                        {qlist.Options.length !== 0 && <b>Options:</b>}
                                        <Stack>

                                            {qlist.Options.map((lrow, index) => (
                                                <>&nbsp;{index + 1}.&nbsp;{lrow}<br></br></>
                                            ))}
                                        </Stack>
                                    </Box>}
                                    <Box sx={{ mb: 2, paddingTop: "10px" }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Answer: {qlist.Answer}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Solution: {qlist.Solution}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid2>
                    ))
                    }
                </>
            )
        }

        const renderSearchedQuestion = (qas) => {
            return (
                <>

                    {
                        qas.MetaText !== "" ?
                            <Box sx={{ paddingTop: "0px" }}>
                                <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>

                                            <h3>Passage:</h3>{qas.MetaText}
                                            <Box sx={{paddingBottom: "20px"}}></Box>
                                            {renderQuestions(qas.Questions)}
                                </Grid2>

                            </Box>
                            :
                            <Box>
                                {renderQuestions(qas.Questions)}
                            </Box>
                    }
                    <table style={{ display: "none" }}>
                        <tbody>
                            {qas.MetaText !== "" && <StyledTableRow>
                                <StyledTableCell component="th" scope="row" colSpan={2}>
                                    <h3>Passage:</h3>{qas.MetaText}
                                </StyledTableCell>
                            </StyledTableRow>}
                            {qas.Questions.map((qlist) => (
                                <StyledTableRow key={qlist.QID}>
                                    <StyledTableCell component="th" scope="row">
                                        <Checkbox checked={selectedQuestions[qlist.QID]} id={qlist.QID} onChange={handleQuestionsSelect} />{qlist.Question} &nbsp;
                                        {qlist.Options.length !== 0 && <Box display="flex" style={{ paddingLeft: "50px" }}>
                                            <Stack>
                                                {qlist.Options.length !== 0 && <h3>Options:</h3>}
                                                {qlist.Options.map((lrow, index) => (
                                                    <>&nbsp;{index + 1}.&nbsp;{lrow}<br></br></>
                                                ))}
                                            </Stack>
                                        </Box>}

                                    </StyledTableCell>
                                    <StyledTableCell>{qlist.Qlevel}</StyledTableCell>
                                </StyledTableRow>
                            ))
                            }
                        </tbody>
                    </table>
                </>
            )
        }
        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Box style={{ padding: "10px 10px 10px 10px" }}>
                    <Card 
                        elevation={6}
                        sx={{
                            borderRadius: 4,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <CardHeader 
                            sx={{ textAlign: 'center', pb: 1 }}
                            title={
                                <Typography 
                                    sx={{ 
                                        fontWeight: 600,
                                        fontSize: '1.125rem',
                                        color: 'text.primary',
                                        letterSpacing: '-0.01em',
                                        textAlign: 'center',
                                        width: '100%'
                                    }} 
                                    variant="h6"
                                >
                                    Search Questions
                                </Typography>
                            } 
                        />
                        <CardContent>
                            <Grid2 container spacing={2}>
                                <Grid2  size={{ xs: 12, sm: 4 }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <ClassIcon sx={{ color: "orange" }} />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Subject
                                        </Typography>
                                    </Stack>
                                    <FormControl fullWidth>
                                        <Select
                                            value={search.subject}
                                            onChange={handleChange}
                                            name="subject"
                                            displayEmpty
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderWidth: '1px',
                                                    borderStyle: 'solid',
                                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'rgba(0, 0, 0, 0.87)',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderWidth: '2px',
                                                    borderColor: 'primary.main',
                                                },
                                            }}
                                        >
                                            {subjects && subjects.map((row) => (
                                                <MenuItem key={row} value={row}>{row}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <SchoolIcon sx={{ color: "brown" }} />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Class
                                        </Typography>
                                    </Stack>
                                    <FormControl fullWidth>
                                        <Select
                                            value={search.class}
                                            onChange={handleChange}
                                            name="class"
                                            displayEmpty
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderWidth: '1px',
                                                    borderStyle: 'solid',
                                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'rgba(0, 0, 0, 0.87)',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderWidth: '2px',
                                                    borderColor: 'primary.main',
                                                },
                                            }}
                                        >
                                            {search.subject && categories[search.subject] && Object.keys(categories[search.subject]).map((cls) => (
                                                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <LabelIcon sx={{ color: "#9c27b0" }} />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Categories
                                        </Typography>
                                    </Stack>
                                    <FormControl fullWidth>
                                        <Select
                                            value={search.category || "Any"}
                                            onChange={handleChange}
                                            name="category"
                                            displayEmpty
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderWidth: '1px',
                                                    borderStyle: 'solid',
                                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'rgba(0, 0, 0, 0.87)',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderWidth: '2px',
                                                    borderColor: 'primary.main',
                                                },
                                            }}
                                        >
                                            <MenuItem value="Any">
                                                <em>Any</em>
                                            </MenuItem>
                                            {search.subject && search.class && categories[search.subject] && categories[search.subject][search.class] && categories[search.subject][search.class].map((row) => (
                                                <MenuItem key={row} value={row}>{row}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mt: 1 }}>
                                <Grid2 size={{ xs: 12, sm: 12 }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <TrendingUpIcon sx={{ color: '#f57c00' }} />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Difficulty Level
                                        </Typography>
                                    </Stack>
                                    <FormControl fullWidth>
                                        <Select
                                            multiple
                                            value={[
                                                ...(search.easy ? ['Easy'] : []),
                                                ...(search.medium ? ['Medium'] : []),
                                                ...(search.advanced ? ['Advanced'] : [])
                                            ]}
                                            onChange={(e) => {
                                                const selected = e.target.value;
                                                setSearch({
                                                    ...search,
                                                    easy: selected.includes('Easy'),
                                                    medium: selected.includes('Medium'),
                                                    advanced: selected.includes('Advanced')
                                                });
                                            }}
                                            displayEmpty
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em style={{ color: 'rgba(0, 0, 0, 0.6)' }}>Select Difficulty</em>;
                                                }
                                                return selected.join(', ');
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                },
                                                '& .MuiSelect-select': {
                                                    backgroundColor: 'background.paper',
                                                    color: 'text.primary',
                                                    fontWeight: 400,
                                                    borderRadius: 2,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    transition: 'all 0.2s ease-in-out',
                                                    '&:hover': {
                                                        borderColor: 'primary.main',
                                                    }
                                                }
                                            }}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: 2,
                                                        marginTop: 1,
                                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        '& .MuiMenuItem-root': {
                                                            borderRadius: 1,
                                                            margin: '4px 8px',
                                                            padding: '10px 16px',
                                                            '&:hover': {
                                                                backgroundColor: 'action.hover',
                                                            },
                                                            '&.Mui-selected': {
                                                                backgroundColor: 'primary.light',
                                                                color: 'primary.contrastText',
                                                                '&:hover': {
                                                                    backgroundColor: 'primary.main',
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem value="Easy">Easy</MenuItem>
                                            <MenuItem value="Medium">Medium</MenuItem>
                                            <MenuItem value="Advanced">Advanced</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>
                            </Grid2>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                                <AsyncButton type="button" variant="contained" color="primary" onClick={handleSearch} loading={searching}>
                                    Search
                                </AsyncButton>
                            </Box>

                        </CardContent>
                    </Card>
                </Box>
                {
                    questions && questions.length > 0 &&
                    <Box sx={{ paddingTop: "20px" }}>
                        <Card 
                            elevation={6}
                            sx={{
                                borderRadius: 4,
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                overflow: 'hidden',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            <CardHeader 
                                sx={{ textAlign: 'center', pb: 1 }}
                                title={
                                    <Typography 
                                        sx={{ 
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }} 
                                        variant="h6"
                                    >
                                        Select from following Questions and Click on Add Questions at bottom to add them to the assignment.
                                    </Typography>
                                } 
                            />
                            <CardContent sx={{paddingTop: "5px"}}>
                                <Grid2 container spacing={2}>
                                    {questions.map((row, index) => (
                                        <Grid2 key={`row-${index}`} size={{ xs: 12, sm: 12, md: 12 }}>
                                            {renderSearchedQuestion(row)}
                                        </Grid2>
                                    ))}
                                </Grid2>
                                <br></br>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <AsyncButton sx={{ textTransform: "initial"}} type="button" variant="contained" color="primary" onClick={handleAddQuestions} loading={addingQuestions}>
                                        <AddCircle/> &nbsp; Add Questions
                                    </AsyncButton>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                }
            </Box>
        )
    }

    const RenderAddedQuestions = () => {

        const [questions, setQuestions] = useState([]);

        const getAssessmentQuestions = async () => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/list`,
                { "Aid": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            if (uinfo.internal) {
                return undefined
            }
            //console.log(uinfo)
            return uinfo.response["QuestionsInfo"]
        }

        useEffect(() => {
            getAssessmentQuestions().then(data => setQuestions(data))
        }, [])


        return (
            <Box style={{ margin: "10px 10px 10px 10px" }}>
                <h3>Added Questions:</h3>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Question</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {questions && questions.map((row, index) => (
                                <StyledTableRow key={`hidden-row-${index}`}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.Qtext} &nbsp;
                                        {
                                            <Tooltip title="Delete">
                                                <IconButton>
                                                    <DeleteIcon type="submit" variant="outlined" color="error"
                                                        onClick={() => { navigate('/app/practice/edit/' + row.QID, { replace: true }) }} />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    /*
    <RenderManuallyAddQuestion />
                    <RenderAskAIForQuestion />
                    <RenderAddedQuestions />
    */
    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Button
                variant="text"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{ color: "blue" }}
            >
                Go Back
            </Button>
            {isStudent() ? (<>You are not allowed to edit this.</>) : (
                <Stack>
                    <RenderSearchAndAddQuestions />
                </Stack>
            )
            }

        </Box>
    );
};

export default AssessmentQuestionEdit;
